import styled from 'styled-components';
import BGBanner from '../../../assests/images/bg-banner.webp';

export const Title = styled.h1`
    max-width:482px;
    width:100%;  
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size: 40px;
    font-weight: 700; 
    line-height: 60px;
    margin-bottom: 20px;  

    @media screen and (max-width:1199px) { 
      font-size: 38px;
      line-height: 50px
    }
    @media screen and (max-width:991px) { 
      font-size: 35px;
      line-height: 45px
    }
    @media screen and (max-width:767px) { 
      font-size: 30px;
      line-height: 38px;
    }
      
    &.page-main-title{
      max-width: 500px;
    }

    &.page-main-title-two{
      max-width: 100%;
    }
    
    &.write-review-text{
    
      
      @media screen and (max-width:1200px) { 
        white-space: inherit;
        padding-top:50px;
      }
    }
`;

export const WriteReviewSection = styled.div`
    background-color:#ddf5f6;
    background-image:url(${BGBanner});
    padding:60px 0 70px 0;
    
    @media screen and (max-width:1199px) {
      padding:50px 0;
    }

    @media screen and (max-width:1024px) {
      padding: 150px 0px 50px;
    }

    @media screen and (max-width:575px) {
      padding: 130px 0px 40px;
    }

    row{
      display: flex;
      justify-content: center;
      align-items: center;
    }
    
    &.press-banner{
      @media screen and (max-width: 1024px){ 
        padding: 177px 0px 96px;
      }
      @media screen and (max-width: 1024px){ 
        padding: 177px 0px 0px;
      }
    }
    &.giving-guides-banner{
      
      @media screen and (max-width: 1024px){ 
        padding: 60px 0px 50px;
      }
      
      @media screen and (max-width: 575px){ 
        padding: 70px 0px 40px;
      }
    }
    
    &.get-started-banner{
      padding: 90px 0px 50px;
       @media screen and (max-width:1024px){ 
               padding: 175px 0px 50px;
         }
         @media screen and (max-width: 991px){ 
               padding: 165px 0px 50px;
         }
    }
         .search-header {
            padding: 1px 4px !important;
         .input-group{
               align-items: center;
           }
        button.btn.btn-outline-success-blue {
           padding: 7px 19px;
          }
         }
          .toprated.test {
           @media screen and (max-width: 991px){ 
              margin-top: 73px;
      }
      }


`;

export const WriteReviewBannerSection = styled.div`
    background-color:#ddf5f6;
    background-image:url(${BGBanner});
    padding:60px 0 70px 0;

    @media screen and (max-width:1199px) {
      padding:50px 0;
    }

    @media screen and (max-width:1024px) {
      padding: 100px 0px 50px;
    }
`;

export const ReviewText = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 18px;
    font-weight: 500;
    line-height: 27px;
    margin-bottom: 0px;
    width:100%;
    max-width: 588px;
    margin-bottom: 0px;

    &:last-child{
      margin-bottom: 0px;
    }

    strong{
        font-weight: 700;
        color:#01606F;
    }
    @media screen and (max-width:767px) { 
      font-size: 16px;
      line-height: 25px;
    }

    &.base-text{
      margin-bottom: 20px;

      &:last-child{
        margin-bottom: 0px;
      }
    }

    &.review-content-p{
      padding-bottom: 20px;
      margin: 0;

      &:last-child{
        padding-bottom: 0px;
      }
    }

    button.btn.btn-primary {
      color: #01606F;
      font-size: 18px;
      font-family: "Jost", sans-serif;
      font-weight: 700;
      line-height: 22px;
      cursor: pointer;
      background: transparent;
      border: none;
      padding: 0;
      vertical-align: baseline !important;
  }
`;

export const ReviewSearch = styled.div`
  margin-top:30px;
`;

export const ReviewSerchBox = styled.div`
  .search-header{
      display: flex;
      align-items: center;
      background: #fff;
      box-shadow: 0px 20px 20px #0000001A;
      border-radius: 10px;
      padding:6px;
      max-width: 680px;
      width: 100%;
      justify-content: space-between;
    .input-group {
         @media screen and (max-width:480px) {
          width: 100% !important;
         }
      }
      @media screen and (max-width:767px) {
        flex-wrap: wrap;
        margin-bottom: 20px;
        gap: 12px;
      }
      
      @media screen and (max-width:480px) {
        justify-content: flex-end;
        padding: 9px !important;
      }
      .zipcode{
          max-width: 150px;          
        .form-control{
          padding-left: 20px !important;
        }          
          &:after {
              background: #333333;
              position: absolute;
              width: 1px;
              height: 40px;
              content: "";
              top: -5px;
        
          }
      }
    
      .input-group{
          width: auto;
        
          .form-control{
              border: none;
              padding-top: 2px;
              padding-bottom: 2px;
              font-family: "Jost", sans-serif;
              font-size: 18px;
              font-weight: 500;
              line-height: 26px;
              padding-left: 0px;
              @media screen and (max-width:767px) { 
                font-size: 16px;
                line-height: 25px;
              }
              &:focus{
                  background: transparent !important;
              }
              &::-webkit-input-placeholder { 
                    color: #333333;
                  }
              &::-moz-placeholder { 
                  color: #333333;
                  }
              &:-ms-input-placeholder { 
                  color: #333333;
                  }
              &:-moz-placeholder { 
                  color: #333333;
              }
          }
      }
      .btn-outline-success{
          background: #01606F;
          border: none;
          color: #fff;
          font-family: "Jost", sans-serif;
          font-size: 16px;
          font-weight: 500;
          line-height: 24px;
          padding: 12px 40px;
          transition: all 0.5s;
          @media screen and (max-width:767px) {
            padding: 8px 20px;
          }
          &:hover{
              background: #FFD495;
              color: #333333;
              transition: all 0.5s;
          }
      }
  }
`;

export const SearchInputBox = styled.div` 
    display: flex;
    align-items: center;
`;

export const InputGroupIcon = styled.div`
    padding-right: 10px;
     .search-group-icon{
        width: 48px;
        min-width:48px;
        height: 48px;
        background: #F9DC70;
        border-radius: 10px;
        padding: 10px;
        
        @media screen and (max-width:767px) {
          width: 30px;
          min-width:30px;
          height: 30px;
          padding: 7px;
          border-radius: 5px;
        } 
    }
`;

export const ReviewRightSection = styled.div`
    background: #FFFFFF ;
    box-shadow: 0px 20px 20px #0000001A;
    border-radius: 15px;
    padding: 10px;
    position: relative;

    @media screen and (max-width: 575px){
      margin-bottom: 10px;
    }
    
    img{
        width:100%;
        display: block;
        border-radius: 10px;
    }
`;

export const LeftQuote = styled.div`
    position: absolute;
    width: 100%;
    max-width: 313px;
    color: #000;
    font-family: "Jost", sans-serif;
    font-size:14px;
    font-weight: 400;
    line-height: 21px;
    margin-bottom: 15px;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 15px;
    
    padding: 15px;
    right: -45px;
    top: -25px;
    box-shadow: 0px 20px 20px #0000001A;

    @media screen and (max-width:  1280px){
      max-width: 250px;
      right: -25px;
    }
    @media screen and (max-width:  1200px){
      right: -10px
    }

    @media screen and (max-width:  991px){
      right: -90px
    }

    @media screen and (max-width:  575px){
      right: -20px;
      top: -20px;
    }
    @media screen and (max-width:  480px){
      right: 0px;
      top: -60px;
    }

    img{
      width: 23px;
      height: 19px;
    }
    
    span{
      display: block;
      margin-bottom: 5px;
    }
`;
export const RightQuote = styled.div`
  color: #000;
  font-family: "Jost", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  margin-bottom: 15px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 20px 20px #0000001A;
  border-radius: 15px;
  position: absolute;
  width: 100%;
  max-width: 313px;
  padding: 15px;
  left: -45px;
  bottom: -25px;

    img{
      width: 23px;
      height: 19px;
    }
    span{
      display: block;
      margin-bottom: 5px;
    }

    @media screen and (max-width: 1024px){
      left: inherit;
      margin-bottom: 0px;
      margin-top: 10px;
    }
`;

export const RightBanner = styled.div`
  padding-left: 0px;
  
  @media screen and (max-width:1024px) { 
    margin-bottom: -97px;
  }
  @media screen and (max-width:991px) { 
    margin-top: 50px;
    margin-bottom: inherit;
  }
  @media screen and (max-width:767px) { 
    margin-top: 30px;
  }
  
  .quote_col {
      display: none;
  }

`;
export const BannerBlueWrapper = styled.div`
    background: #01606F 0% 0% no-repeat padding-box;
    border-radius: 15px;
    padding:20px;

    &.blue-banner{
      display:none;
    }
`;

export const BadgeSmallText = styled.div`
  color: #000000;
  font-family: "Jost", sans-serif;
  font-size:18px;
  font-weight:700;
  line-height: 26px;
  margin-bottom: 20px;

  &.base-small-text{
    display: none;
  }
`;

export const BannerBlueTitle = styled.h2`
  color: #fff;
  font-family: "Jost", sans-serif;
  font-size:18px;
  font-weight: 700;
  line-height: 30px;
  margin-bottom: 10px;
  border-bottom: 1px solid rgb(51 167 174 / 50%);
  padding-bottom: 10px;
  text-align: center;   
`;

export const BannerBlueText = styled.p`
  color: #fff;
  font-family: "Jost", sans-serif;
  font-size:18px;
  font-weight:400;
  line-height: 30px;
  margin-bottom: 0px;
  padding-bottom: 0px;
  text-align: center;
`;

export const ReviewTextBold = styled.strong`
    color: #01606F;
    font-size: 18px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 26px;
    display: block;
`;


export const ReviewTextState = styled.strong`
    color: #01606F;
    font-size: 18px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 26px;
    cursor: pointer;
`;

export const ReviewTextStrong = styled.strong`
    color: #01606F;
    font-size: 18px;
    font-family: "Jost", sans-serif;
    font-weight: 700;
    line-height: 22px;
    cursor: pointer;
`;